import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AddCircleOutline, DeleteOutline, Edit } from "@material-ui/icons";
import React, { useEffect, useState, useReducer } from "react";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import Title from "../../components/Title";
import ListagemTicketModal from "../../components/ListagemTicketModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import { toast } from "react-toastify";
import api from "../../services/api";
import FormatTime from "../../helpers/FormatTime";
import StatusIndicatorTicket from "../../components/StatusIndicatorTicket";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

const filterOptions = createFilterOptions({
  trim: true,
});

const reducer = (state, action) => {
  if (action.type === "LOAD_TICKETS") {
    if (action.payload.isAcao) {
      return action.payload.tickets;
    }

    const tickets = action.payload.tickets;

    const newTickets = [];

    tickets.forEach((ticket) => {
      const ticketIndex = state.findIndex((c) => c.id === ticket.id);
      if (ticketIndex !== -1) {
        state[ticketIndex] = ticket;
      } else {
        newTickets.push(ticket);
      }
    });

    return [...state, ...newTickets];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: "8px",
    margin: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  tableHead: {
    "& th": {
      position: "relative",
      padding: "8px",
      "&:not(:last-child)::after": {
        content: '""',
        position: "absolute",
        top: "25%",
        bottom: "25%",
        right: 0,
        width: "1px",
        backgroundColor: "rgba(128, 128, 128, 0.5)",
      },
    },
  },
  tableBody: {
    "& td": {
      position: "relative",
      padding: "8px",
      "&:not(:last-child)::after": {
        content: '""',
        position: "absolute",
        top: "25%",
        bottom: "25%",
        right: 0,
        width: "1px",
        backgroundColor: "rgba(128, 128, 128, 0.7)",
      },
    },
    "& tr:nth-of-type(odd)": {
      backgroundColor: "#f9f9f9",
    },
    "& tr:nth-of-type(even)": {
      backgroundColor: "#e9e9e9",
    },
  },
}));

const ListagemTickets = () => {
  const classes = useStyles();

  // #region States
  const [loading, setLoading] = useState(false);
  const [acaoRealizada, setAcaoRealizada] = useState(false);
  const [tickets, dispatch] = useReducer(reducer, []);

  // #region Campos Filtros
  const [pesquisaContato, setPesquisaContato] = useState("");
  const [pesquisaCliente, setPesquisaCliente] = useState("");
  const [pesquisaDescricao, setPesquisaDescricao] = useState("");
  const [pesquisaUsuario, setPesquisaUsuario] = useState("");
  const [pesquisaNumeroTicket, setPesquisaNumeroTicket] = useState("");
  // #endregion Campos Filtros

  // #region Obter Listagem
  const [pageNumber, setPageNumber] = useState(1);
  const [ticketIdModal, setTicketIdModal] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  // #endregion Obter Listagem

  // #region Paginacao
  const [hasMore, setHasMore] = useState(false);
  // #endregion Paginacao

  // #region Ticket Modal
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [tituloOperacao, setTituloOperacao] = useState("Criar");
  // #endregion Ticket Modal

  // #region Deletar Ticket Modal
  const estadoInicialDeletarTicketModal = {
    action: "",
    title: "",
    message: "",
    ticketId: "",
    open: false,
  };
  const [deletarTicketModalInfo, setDeletarTicketModalInfo] = useState(
    estadoInicialDeletarTicketModal
  );
  const [deletarTicketModalOpen, setDeletarTicketModalOpen] = useState(false);
  // #endregion Deletar Ticket Modal

  // #region Setor
  const [optionsSetor, setOptionsSetor] = useState([]);
  const [textoPesquisaSetor, setTextoPesquisaSetor] = useState("");
  const [setorSelecionada, setSetorSelecionada] = useState(null);
  // #endregion Setor

  // #endregion States

  // #region Filtro
  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [
    pesquisaContato,
    pesquisaCliente,
    pesquisaDescricao,
    setorSelecionada,
    pesquisaNumeroTicket,
    pesquisaUsuario,
  ]);
  // #endregion Filtro

  // #region Obter Listagem
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchListagemTickets = async () => {
        try {
          const { data } = await api.get("/listagem-tickets", {
            params: {
              pageNumber,
              pesquisaContato,
              pesquisaDescricao,
              setorSelecionada: setorSelecionada?.name ?? "",
              pesquisaCliente,
              pesquisaNumeroTicket,
              pesquisaUsuario,
            },
          });

          dispatch({
            type: "LOAD_TICKETS",
            payload: { tickets: data.tickets, isAcao: acaoRealizada },
          });
          setHasMore(data.hasMore);
          setTotalCount(data.count);
          setLoading(false);
          setAcaoRealizada(false);
        } catch (error) {
          toast.error("Erro ao carregar listagem de Tickets!");
        }
      };

      fetchListagemTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    pageNumber,
    pesquisaCliente,
    pesquisaContato,
    pesquisaDescricao,
    setorSelecionada,
    acaoRealizada,
    pesquisaNumeroTicket,
    pesquisaUsuario,
  ]);

  // #endregion Obter Listagem

  // #region Obter Paginação
  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };
  // #endregion Obter Paginação

  // #region Ticket Modal
  const handleCloseEditarTicketModal = () => {
    setTicketModalOpen(false);
  };

  const handleSubmitEditarTicketModal = (data) => {
    setTicketModalOpen(false);
    setAcaoRealizada(true);
  };

  const handleOpenTicketModal = (operacao = "Criar" | "Editar", ticketId) => {
    setTituloOperacao(operacao);
    setTicketIdModal(String(ticketId));
    setTicketModalOpen(true);
  };
  // #endregion Ticket Modal

  // #region Deletar Ticket Modal
  const handleOpenDeletarTicketModal = (action, ticketId) => {
    setDeletarTicketModalInfo({
      action: action,
      title: `Excluir ticket - #${ticketId}`,
      message: `Deseja realmente excluir o Ticket - #${ticketId}?`,
      ticketId: ticketId,
    });

    setDeletarTicketModalOpen(true);
  };

  const handleSubmitDeletarTicketModal = async () => {
    if (deletarTicketModalInfo.action === "delete") {
      try {
        await api.delete(
          `/listagem-tickets/${deletarTicketModalInfo.ticketId}`
        );
        toast.success("Ticket excluído com sucesso!");
        setAcaoRealizada(true);
      } catch (err) {
        toast.error(err.response.data.error);
      }
    }

    setDeletarTicketModalOpen(false);
    setDeletarTicketModalInfo(estadoInicialDeletarTicketModal);
    setPageNumber(1);
  };

  // #endregion Deletar Ticket Modal

  // #region Change dos Autocompletes
  useEffect(() => {
    if (textoPesquisaSetor.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-setor/", {
            params: {
              texto: textoPesquisaSetor,
            },
          });

          setOptionsSetor(data.setores);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaSetor]);
  // #endregion  Change dos Autocompletes

  return (
    <MainContainer>
      <ListagemTicketModal
        modalOpen={ticketModalOpen}
        onClose={handleCloseEditarTicketModal}
        onSubmit={handleSubmitEditarTicketModal}
        ticketid={ticketIdModal}
        tituloBotaoSubmit={tituloOperacao}
      />
      <ConfirmationModal
        title={deletarTicketModalInfo.title}
        open={deletarTicketModalOpen}
        onClose={setDeletarTicketModalOpen}
        onConfirm={handleSubmitDeletarTicketModal}
      >
        {deletarTicketModalInfo.message}
      </ConfirmationModal>
      <MainHeader>
        <Title>{`Tickets (${tickets.length}/${totalCount})`}</Title>
        <MainHeaderButtonsWrapper>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOpenTicketModal("Criar", "0");
            }}
          >
            <AddCircleOutline />
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <TextField
        style={{ padding: 10 }}
        variant="outlined"
        size="small"
        placeholder="Filtro por Contato"
        onChange={(e) => setPesquisaContato(e.target.value)}
      />
      <TextField
        style={{ padding: 10 }}
        variant="outlined"
        size="small"
        placeholder="Filtro por Cliente"
        onChange={(e) => setPesquisaCliente(e.target.value)}
      />
      <div style={{ display: "flex", gap: "10px", width: "100%" }}>
        <TextField
          style={{ flex: 1, padding: 10 }}
          variant="outlined"
          size="small"
          placeholder="Filtro por Número do Ticket"
          onChange={(e) => setPesquisaNumeroTicket(e.target.value)}
        />
        <TextField
          style={{ flex: 1, padding: 10 }}
          variant="outlined"
          size="small"
          placeholder="Filtro por Descrição do Ticket"
          onChange={(e) => setPesquisaDescricao(e.target.value)}
        />
      </div>
      <div style={{ display: "flex", gap: "10px", width: "100%" }}>
        <Autocomplete
          style={{ flex: 1, padding: "2px 10px 0px 10px" }}
          getOptionLabel={(option) => `${option.name || setorSelecionada.name}`}
          onChange={(e, newValue) => {
            setSetorSelecionada(newValue);
          }}
          id="setorSelecionada"
          name="setorSelecionada"
          value={setorSelecionada}
          options={optionsSetor}
          filterOptions={filterOptions}
          freeSolo
          autoHighlight
          noOptionsText="Nenhuma opção encontrada..."
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filtro por Setor"
              variant="outlined"
              onChange={(e) => setTextoPesquisaSetor(e.target.value)}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              margin="dense"
            />
          )}
        />
        <TextField
          style={{ flex: 1, padding: 10 }}
          variant="outlined"
          size="small"
          placeholder="Filtro por Usuário"
          onChange={(e) => setPesquisaUsuario(e.target.value)}
        />
      </div>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <Table size="small">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell align="right">{"Nº"}</TableCell>
              <TableCell align="left">{"Cliente"}</TableCell>
              <TableCell align="left">{"Contato"}</TableCell>
              <TableCell align="left">{"Descrição do Ticket"}</TableCell>
              <TableCell align="left">{"Plataforma"}</TableCell>
              <TableCell align="left">{"Módulo/Funcionalidade"} </TableCell>
              <TableCell align="left">{"Motivo"}</TableCell>
              <TableCell align="left">{"Tempo Real"}</TableCell>
              <TableCell align="center">{"Status"}</TableCell>
              <TableCell align="left">{"Ações"}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            <>
              {tickets.map((ticket) => (
                <TableRow key={ticket.id}>
                  <TableCell align="right">{ticket.id}</TableCell>
                  <TableCell align="left">
                    {ticket.pessoa?.nomeRazaoSocial}
                  </TableCell>
                  <TableCell align="left">{ticket.contato?.nome}</TableCell>
                  <TableCell align="left">{ticket.descricao}</TableCell>
                  <TableCell align="left">{ticket.plataformaSistema}</TableCell>
                  <TableCell align="left">
                    {ticket.moduloFuncionalidade}
                  </TableCell>
                  <TableCell align="left">
                    {ticket.motivoClassificacao}
                  </TableCell>
                  <TableCell align="left">
                    {FormatTime(ticket.tempoReal) ?? "00:00:00"}
                  </TableCell>
                  <TableCell align="center">
                    <StatusIndicatorTicket status={ticket.status} />
                  </TableCell>
                  <TableCell align="left">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenTicketModal("Editar", ticket.id)}
                    >
                      <Edit color="secondary" />
                    </IconButton>
                    <IconButton
                      style={{
                        display:
                          ticket.canalComunicacao !== "Whats Integrado"
                            ? "flex"
                            : "none",
                      }}
                      size="small"
                      onClick={(e) => {
                        handleOpenDeletarTicketModal("delete", ticket.id);
                      }}
                    >
                      <DeleteOutline color="secondary" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton columns={10} />}
            </>
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default ListagemTickets;
